module.exports = __webpack_public_path__ + "static/Tarakli-faiza-110e1fa6cb4c954139a5c2662f6933c6.jpg";